/**
 * 帳票一括作成の依頼ボタン（G2・G3 の一覧画面から利用する公開部品）。担当: G4
 *
 * @example
 *   <BulkReportButton reportId="R-03" params={{ businessOperatorId, from, to }} label="帳票一括作成" />
 * 依頼後は「帳票一括作成ジョブ」（S-96）で状態確認・ZIP ダウンロードできる旨をトーストで案内する。
 */
import { useNavigate } from 'react-router-dom';
import { Files } from 'lucide-react';
import { Button, useToast } from '@/components';
import { useFiscalYear } from '@/fiscal-year/FiscalYearProvider';
import { errorMessage } from '@/lib/api';
import { useRequestReportJob, type BulkReportId } from './api';

export interface BulkReportButtonProps {
  reportId: BulkReportId;
  params: Record<string, unknown>;
  label?: string;
  disabled?: boolean;
  /** 依頼後にジョブ一覧へ遷移する（既定 false：トーストで案内） */
  navigateAfter?: boolean;
}

export function BulkReportButton({ reportId, params, label = '帳票一括作成', disabled, navigateAfter }: BulkReportButtonProps) {
  const { year, yearPath } = useFiscalYear();
  const toast = useToast();
  const navigate = useNavigate();
  const request = useRequestReportJob();
  const onClick = async () => {
    try {
      const { id } = await request.mutateAsync({ reportId, fiscalYear: year, params });
      toast.success('帳票一括作成を受け付けました', `受付番号 ${id}。「帳票一括作成ジョブ」画面で作成状況の確認・ZIP のダウンロードができます。`);
      if (navigateAfter) navigate(yearPath('report-jobs'));
    } catch (e) {
      toast.error('依頼できませんでした', errorMessage(e));
    }
  };
  return (
    <Button icon={<Files size={16} />} loading={request.isPending} disabled={disabled} onClick={() => void onClick()}>
      {label}
    </Button>
  );
}
